export default __webpack_public_path__ + "static/0204-f90554fdac56857a085c01f19d8ff071.png";